// src/components/common/EditButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@/icons';
import './EditButton.css';

interface EditButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`edit-button-table ${className}`}
    >
      <FontAwesomeIcon icon={faPenToSquare} /> Editar
    </button>
  );
};

export default EditButton;
